import React from 'react';
import './navbar.css';
import { Bars, Nav, NavIcon } from './NavbarElements';
import img from "../../images/logo.png";   // Yantra logo
import clg from "../../assets/image.png"; // College logo

const Navbar = ({ toggle }) => {
  return (
    <>
      {/* Navbar with animated gradient background */}
      <Nav className="animated-bg shadow-lg fixed w-full top-0 z-50">
        <div className="flex items-center justify-center px-4 sm:px-8 py-2 gap-6 sm:gap-10 md:gap-16">
          
          {/* Left - College Logo */}
          <a
            href="https://jntuacep.ac.in"
            target="_blank"
            rel="noopener noreferrer"
            className="flex-shrink-0"
          >
            <img
              src={clg}
              alt="College Logo"
              loading="lazy"
              className="logo-hover rounded-lg shadow-md bg-white p-1
              max-h-16 sm:max-h-20 md:max-h-24 object-contain"
            />
          </a>

          {/* Center Title */}
          {/* Center Title */}
<h1
  className="title-animate text-2xl sm:text-4xl md:text-5xl lg:text-6xl tracking-widest text-white drop-shadow-lg text-center"
  style={{ fontFamily: "BatmanForever" }}
>
  YANTRA <span className="ml-2">2K25</span>
</h1>


          {/* Right - Yantra Logo */}
          <div className="flex-shrink-0">
            <img
              src={img}
              alt="Yantra Logo"
              className="logo-hover rounded-lg p-1 
              max-h-16 sm:max-h-20 md:max-h-24 object-contain"
            />
          </div>
        </div>

        {/* Mobile toggle button */}
        <NavIcon onClick={toggle}>
          <Bars className="text-white hover:text-pink-400 transition" />
        </NavIcon>
      </Nav>
    </>
  );
};

export default Navbar;
